var exports = {
  "or": "VoiceParticipantTile.module__cursorPointer___TTBBNm",
  "yy": "VoiceParticipantTile.module__watchStreamOverlay___TTBBNm",
  "R6": "VoiceParticipantTile.module__watchStreamButtons___TTBBNm",
  "kV": "VoiceParticipantTile.module__watchStreamButton___TTBBNm",
  "LY": "VoiceParticipantTile.module__watchStreamButtonLabel___TTBBNm",
  "MO": "VoiceParticipantTile.module__watchStreamSecondaryButton___TTBBNm",
  "gk": "VoiceParticipantTile.module__streamInfoHud___TTBBNm",
  "FI": "VoiceParticipantTile.module__streamEndedOverlay___TTBBNm",
  "Zz": "VoiceParticipantTile.module__screenShareBufferingFrame___TTBBNm",
  "Wo": "VoiceParticipantTile.module__streamEndedContent___TTBBNm",
  "$k": "VoiceParticipantTile.module__streamEndedTitle___TTBBNm",
  "BL": "VoiceParticipantTile.module__streamEndedButton___TTBBNm",
  "Ec": "VoiceParticipantTile.module__avatarRing___TTBBNm",
  "Gi": "VoiceParticipantTile.module__avatarRingSpeaking___TTBBNm",
  "kA": "VoiceParticipantTile.module__tileAvatarRing___TTBBNm",
  "z3": "VoiceParticipantTile.module__focusOverlay___TTBBNm",
  "gD": "VoiceParticipantTile.module__focusOverlayIcon___TTBBNm",
  "yI": "VoiceParticipantTile.module__videoDisabledOverlay___TTBBNm",
  "xS": "VoiceParticipantTile.module__videoDisabledIcon___TTBBNm",
  "if": "VoiceParticipantTile.module__participantIconMuted___TTBBNm",
  "Yc": "VoiceParticipantTile.module__participantIconRed___TTBBNm",
  "io": "VoiceParticipantTile.module__participantIconWhite___TTBBNm",
  "Gl": "VoiceParticipantTile.module__participantNameText___TTBBNm",
  "Zi": "VoiceParticipantTile.module__participantConnectionText___TTBBNm",
  "P4": "VoiceParticipantTile.module__tilePillIcon___TTBBNm",
  "cj": "VoiceParticipantTile.module__streamAudioSlotMuted___TTBBNm",
  "Sr": "VoiceParticipantTile.module__avatarFlexShrink___TTBBNm",
  "iW": "VoiceParticipantTile.module__previewPopover___TTBBNm",
  "OG": "VoiceParticipantTile.module__frozenFrame___TTBBNm",
  "Wz": "VoiceParticipantTile.module__dimmedLastFrame___TTBBNm",
  "xR": "VoiceParticipantTile.module__cornerBufferingIndicator___TTBBNm",
  "kJ": "VoiceParticipantTile.module__screensharePreviewBackground___TTBBNm",
  "A": "VoiceParticipantTile.module__streamPreviewUnavailableSurface___TTBBNm",
  "Ae": "VoiceParticipantTile.module__focusedPlaceholderScreenSurface___TTBBNm",
  "SQ": "VoiceParticipantTile.module__focusedPlaceholderCameraOverlay___TTBBNm",
  "xh": "VoiceParticipantTile.module__focusedPlaceholderIconLayer___TTBBNm",
  "Iy": "VoiceParticipantTile.module__focusedPlaceholderIcon___TTBBNm",
  "uA": "VoiceParticipantTile.module__focusedPlaceholderLiveBadge___TTBBNm",
  "mf": "VoiceParticipantTile.module__focusedPlaceholderAvatarDimmed___TTBBNm",
  "vB": "VoiceParticipantTile.module__selfStreamOverlay___TTBBNm",
  "Ft": "VoiceParticipantTile.module__paused___TTBBNm",
  "xz": "VoiceParticipantTile.module__selfStreamPreviewPaused___TTBBNm",
  "ck": "VoiceParticipantTile.module__pausedIcon___TTBBNm",
  "Ok": "VoiceParticipantTile.module__pausedText___TTBBNm",
  "I5": "VoiceParticipantTile.module__pausedSubtext___TTBBNm",
  "AS": "VoiceParticipantTile.module__watchStreamPrimaryButton___TTBBNm",
  "DE": "VoiceParticipantTile.module__groupExpandPillSlot___TTBBNm",
  "GX": "VoiceParticipantTile.module__groupExpandPillSign___TTBBNm",
};

module.exports = exports;
